import { ReactNode } from 'react';
import { isMobile } from 'react-device-detect';

import artificialismo from '../assets/museu/artificialismo.png';
import calma from '../assets/museu/calma.png';
import carinho from '../assets/museu/carinho.png';
import crenca from '../assets/museu/crenca.png';
import complexidade from '../assets/museu/complexidade.png';
import criatividade from '../assets/museu/criatividade.png';
import descrenca from '../assets/museu/descrenca.png';
import despreocupacao from '../assets/museu/despreocupacao.png';
import devaneio from '../assets/museu/devaneio.png';
import diversao from '../assets/museu/diversao.png';
import duvidas from '../assets/museu/duvidas.png';
import euforia from '../assets/museu/euforia.png';
import falsidade from '../assets/museu/falsidade.png';
import frieza from '../assets/museu/frieza.png';
import histeria from '../assets/museu/histeria.png';
import ilusao from '../assets/museu/ilusao.png';
import indiferenca from '../assets/museu/indiferenca.png';
import inocencia from '../assets/museu/inocencia.png';
import leveza from '../assets/museu/leveza.png';
import miseria from '../assets/museu/miseria.png';
import mudanca from '../assets/museu/mudanca.png';
import ocultacao from '../assets/museu/ocultacao.png';
import ordinariedade from '../assets/museu/ordinariedade.png';
import paranoia from '../assets/museu/paranoia.png';
import pavor from '../assets/museu/pavor.png';
import perfeicao from '../assets/museu/perfeicao.png';
import plenitude from '../assets/museu/plenitude.png';
import reflexao from '../assets/museu/reflexao.png';
import sossego from '../assets/museu/sossego.png';
import surpresa from '../assets/museu/surpresa.png';
import tedio from '../assets/museu/tedio.png';
import tolice from '../assets/museu/tolice.png';
import tranquilidade from '../assets/museu/tranquilidade.png';

import artificialismoBig from '../assets/museu/artificialismoBig.png';
import calmaBig from '../assets/museu/calmaBig.png';
import carinhoBig from '../assets/museu/carinhoBig.png';
import crencaBig from '../assets/museu/crencaBig.png';
import complexidadeBig from '../assets/museu/complexidadeBig.png';
import criatividadeBig from '../assets/museu/criatividadeBig.png';
import descrencaBig from '../assets/museu/descrencaBig.png';
import despreocupacaoBig from '../assets/museu/despreocupacaoBig.png';
import devaneioBig from '../assets/museu/devaneioBig.png';
import diversaoBig from '../assets/museu/diversaoBig.png';
import duvidasBig from '../assets/museu/duvidasBig.png';
import euforiaBig from '../assets/museu/euforiaBig.png';
import falsidadeBig from '../assets/museu/falsidadeBig.png';
import friezaBig from '../assets/museu/friezaBig.png';
import histeriaBig from '../assets/museu/histeriaBig.png';
import ilusaoBig from '../assets/museu/ilusaoBig.png';
import indiferencaBig from '../assets/museu/indiferencaBig.png';
import inocenciaBig from '../assets/museu/inocenciaBig.png';
import levezaBig from '../assets/museu/levezaBig.png';
import miseriaBig from '../assets/museu/miseriaBig.png';
import mudancaBig from '../assets/museu/mudancaBig.png';
import ocultacaoBig from '../assets/museu/ocultacaoBig.png';
import ordinariedadeBig from '../assets/museu/ordinariedadeBig.png';
import paranoiaBig from '../assets/museu/paranoiaBig.png';
import pavorBig from '../assets/museu/pavorBig.png';
import perfeicaoBig from '../assets/museu/perfeicaoBig.png';
import plenitudeBig from '../assets/museu/plenitudeBig.png';
import reflexaoBig from '../assets/museu/reflexaoBig.png';
import sossegoBig from '../assets/museu/sossegoBig.png';
import surpresaBig from '../assets/museu/surpresaBig.png';
import tedioBig from '../assets/museu/tedioBig.png';
import toliceBig from '../assets/museu/toliceBig.png';
import tranquilidadeBig from '../assets/museu/tranquilidadeBig.png';

import credits from '../assets/museu/credits.png';
import intro from '../assets/museu/intro.png';
import painting from '../assets/museu/painting.png';
import sign from '../assets/museu/sign.png';
import warning from '../assets/museu/warning.png';

import News from './infos/news';
import Credits from './infos/credits';
import Carinha from './infos/carinha';
import Intro from './infos/intro';
import Interactive from './infos/interactive';
import Custom from './infos/custom';
import Blocked from './infos/blocked';

export interface ICarinha {
  key: string;
  x: number;
  y: number;
  src?: string;
  dir: 'right' | 'left';
  isOnFloor?: boolean;
  onlyDesktop?: boolean;
  description: ReactNode;
}

const carinhas: ICarinha[] = [
  {
    key: 'falsidade',
    x: 4,
    y: 11,
    src: falsidade,
    dir: 'left',
    description: <Carinha name='Falsidade' image={falsidadeBig} />,
  },
  {
    key: 'frieza',
    x: 4,
    y: 5,
    src: frieza,
    dir: 'right',
    description: <Carinha name='Frieza' image={friezaBig} />,
  },
  {
    key: 'histeria',
    x: 2,
    y: 5,
    src: histeria,
    dir: 'right',
    description: <Carinha name='Histeria' image={histeriaBig} />,
  },
  {
    key: 'ilusao',
    x: 11,
    y: 9,
    src: ilusao,
    dir: 'left',
    description: <Carinha name='Ilusão' image={ilusaoBig} />,
  },
  {
    key: 'indiferenca',
    x: 11,
    y: 7,
    src: indiferenca,
    dir: 'left',
    description: <Carinha name='Indiferença' image={indiferencaBig} />,
  },
  {
    key: 'inocencia',
    x: 6,
    y: 5,
    src: inocencia,
    dir: 'right',
    description: <Carinha name='Inocência' image={inocenciaBig} />,
  },
  {
    key: 'surpresa',
    x: 4,
    y: 13,
    src: surpresa,
    dir: 'left',
    description: <Carinha name='Surpresa' image={surpresaBig} />,
  },
  {
    key: 'carinho',
    x: 8,
    y: 5,
    src: carinho,
    dir: 'right',
    description: <Carinha name='Carinho' image={carinhoBig} />,
  },
  {
    key: 'complexidade',
    x: 10,
    y: 5,
    src: complexidade,
    dir: 'right',
    description: <Carinha name='Complexidade' image={complexidadeBig} />,
  },
  {
    key: 'artificialismo',
    x: 11,
    y: 14,
    src: artificialismo,
    dir: 'left',
    description: <Carinha name='Artificialismo' image={artificialismoBig} />,
  },
  {
    key: 'duvidas',
    x: 7,
    y: 12,
    src: duvidas,
    dir: 'right',
    description: <Carinha name='Dúvidas' image={duvidasBig} />,
  },
  {
    key: 'calma',
    x: 11,
    y: 16,
    src: calma,
    dir: 'left',
    description: <Carinha name='Calma' image={calmaBig} />,
  },
  {
    key: 'crenca',
    x: 11,
    y: 19,
    src: crenca,
    dir: 'left',
    description: <Carinha name='Crença' image={crencaBig} />,
  },
  {
    key: 'descrenca',
    x: 21,
    y: 19,
    src: descrenca,
    dir: 'left',
    description: <Carinha name='Descrença' image={descrencaBig} />,
  },
  {
    key: 'miseria',
    x: 21,
    y: 17,
    src: miseria,
    dir: 'left',
    description: <Carinha name='Miséria' image={miseriaBig} />,
  },
  {
    key: 'despreocupacao',
    x: 19,
    y: 7,
    src: despreocupacao,
    dir: 'right',
    description: <Carinha name='Despreocupação' image={despreocupacaoBig} />,
  },
  {
    key: 'ocultacao',
    x: 21,
    y: 13,
    src: ocultacao,
    dir: 'left',
    description: <Carinha name='Ocultação' image={ocultacaoBig} />,
  },
  {
    key: 'ordinariedade',
    x: 21,
    y: 11,
    src: ordinariedade,
    dir: 'left',
    description: <Carinha name='Ordinariedade' image={ordinariedadeBig} />,
  },
  {
    key: 'perfeicao',
    x: 21,
    y: 9,
    src: perfeicao,
    dir: 'left',
    description: <Carinha name='Perfeição' image={perfeicaoBig} />,
  },
  {
    key: 'plenitude',
    x: 26,
    y: 16,
    src: plenitude,
    dir: 'left',
    description: <Carinha name='Plenitude' image={plenitudeBig} />,
  },
  {
    key: 'reflexao',
    x: 26,
    y: 14,
    src: reflexao,
    dir: 'left',
    description: <Carinha name='Reflexão' image={reflexaoBig}  />,
  },
  {
    key: 'tedio',
    x: 26,
    y: 12,
    src: tedio,
    dir: 'left',
    description: <Carinha name='Tédio' image={tedioBig} />,
  },
  {
    key: 'tolice',
    x: 26,
    y: 19,
    src: tolice,
    dir: 'left',
    description: <Carinha name='Tolice' image={toliceBig} />,
  },
  {
    key: 'tranquilidade',
    x: 16,
    y: 6,
    src: tranquilidade,
    dir: 'left',
    description: <Carinha name='Tranquilidade' image={tranquilidadeBig}  />,
  },
  {
    key: 'diversao',
    x: 14,
    y: 5,
    src: diversao,
    dir: 'right',
    description: <Carinha name='Diversão' image={diversaoBig} />,
  },
  {
    key: 'euforia',
    x: 17,
    y: 7,
    src: euforia,
    dir: 'right',
    description: <Carinha name='Euforia' image={euforiaBig} />,
  },
  {
    key: 'criatividade',
    x: 33,
    y: 19,
    src: criatividade,
    dir: 'left',
    description: <Carinha name='Criatividade' image={criatividadeBig} />,
  },
  {
    key: 'devaneio',
    x: 33,
    y: 17,
    src: devaneio,
    dir: 'left',
    description: <Carinha name='Devaneio' image={devaneioBig} />,
  },
  {
    key: 'leveza',
    x: 33,
    y: 15,
    src: leveza,
    dir: 'left',
    description: <Carinha name='Leveza' image={levezaBig} />,
  },
  {
    key: 'paranoia',
    x: 33,
    y: 13,
    src: paranoia,
    dir: 'left',
    description: <Carinha name='Paranoia' image={paranoiaBig} />,
  },
  {
    key: 'sossego',
    x: 33,
    y: 11,
    src: sossego,
    dir: 'left',
    description: <Carinha name='Sossego' image={sossegoBig} />,
  },


  {
    key: 'mudanca',
    x: 24,
    y: 7,
    src: mudanca,
    dir: 'right',
    description: <Carinha name='Mudança' image={mudancaBig} />,
  },
  {
    key: 'pavor',
    x: 26,
    y: 7,
    src: pavor,
    dir: 'right',
    description: <Carinha name='Pavor' image={pavorBig} />,
  },


  {
    key: 'creditos',
    x: 4,
    y: 18,
    src: credits,
    dir: 'left',
    description: <Credits />,
  },
  {
    key: 'intro',
    x: 1,
    y: 10,
    src: intro,
    dir: 'right',
    description: <Intro />,
  },

  {
    key: 'novidades',
    x: 31,
    y: 3,
    src: sign,
    dir: 'right',
    isOnFloor: true,
    description: <News />,
  },
  {
    key: 'novidades 2',
    x: 32,
    y: 3,
    dir: 'right',
    isOnFloor: true,
    description: <News />,
  },

  {
    key: 'interactive-intro',
    x: 19,
    y: 0,
    src: intro,
    dir: 'right',
    description: <Interactive />,
  },
  {
    key: 'interactive-1',
    x: 16,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-1' key={'interactive-1'} index={0} />,
  },
  {
    key: 'interactive-2',
    x: 14,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-2' key={'interactive-2'} index={1} />,
  },
  {
    key: 'interactive-3',
    x: 12,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-3' key={'interactive-3'} index={2} />,
  },
  {
    key: 'interactive-4',
    x: 10,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-4' key={'interactive-4'} index={3} />,
  },
  {
    key: 'interactive-5',
    x: 8,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-5' key={'interactive-5'} index={4} />,
  },
  {
    key: 'interactive-6',
    x: 6,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-6' key={'interactive-6'} index={5} />,
  },
  {
    key: 'interactive-7',
    x: 4,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-7' key={'interactive-7'} index={6} />,
  },
  {
    key: 'interactive-8',
    x: 2,
    y: 0,
    src: painting,
    dir: 'right',
    description: <Custom id='interactive-8' key={'interactive-8'} index={7} />,
  },
];

if (isMobile) {
  carinhas.push({
    key: 'mobile-warning',
    x: 20,
    y: 3,
    src: warning,
    dir: 'left',
    isOnFloor: true,
    onlyDesktop: true,
    description: <Blocked />,
  });
}

export default carinhas;

